import { render } from "./WithBorders.vue?vue&type=template&id=44097194"
import script from "./WithBorders.vue?vue&type=script&lang=ts"
export * from "./WithBorders.vue?vue&type=script&lang=ts"
script.render = render

export default script